import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'
import { Box } from '@mui/system'
import { CircularProgress } from '@mui/material'
import CourseCard from '../../../components/CourseCard'
import { UserCourseState } from '../../../features/types'
import { courseApiSlice } from '../../../features/course/courseSlice'
import { H3 } from '../../../layouts/TextStyles'
import GetCourseOptions from './components/GetCourseOptions'

const myCoursesPage = () => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const { data: courses = [], isFetching: isFetchingCourses } =
        courseApiSlice.useFetchAllUserCoursesQuery(undefined, {
            refetchOnMountOrArgChange: true,
        })

    const handleNavigate = (course: UserCourseState) => {
        navigate(`/my-courses/${course.userCourseEnrollId}`, {
            state: { course: course },
        })
    }

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'myCourses' })}</H3>
                    </Title>
                </Header>

                <Box
                    sx={{
                        display: 'flex',
                        '@media screen and (max-width: 500px)': {
                            flexDirection: 'column',
                        },
                    }}
                >
                    <GetCourseOptions />
                    
                    {isFetchingCourses ? (
                        <CircularProgress />
                    ) : courses.length ? (
                        courses.map((course) => (
                            <CourseCard
                                key={course.courseId}
                                course={course}
                                onNavigate={handleNavigate}
                            />
                        ))
                    ) : (
                        formatMessage({ id: 'noData' })
                    )}
                </Box>
            </Content>
        </Wrapper>
    )
}

export default myCoursesPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Content = styled.div`
    background-color: #fff;
    border-radius: 16px;
    padding: 20px 40px;
    min-height: 80vh;
    margin-top: 20px;

    @media screen and (max-width: 500px) {
        padding: 24px 16px;
    }
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`
